import { getAuth, initializeAuth } from 'firebase/auth'

/**
 * Firebase app 하나당 Auth를 정확히 한 번만 초기화한다.
 *
 * initializeAuth()는 같은 app에 두 번 호출되면 auth/already-initialized를 던진다.
 * 앱(기본 app)과 관리자 웹(이름 있는 'suguide-admin' app)은 서로 다른 app을 쓰므로
 * 원래는 충돌하지 않아야 하지만, 두 모듈이 한 번들에 함께 실려 같은 app을 잡으면
 * 두 번째 호출이 그대로 터져 화면 전체가 비어버린다.
 *
 * 여기서는 "이미 auth가 있는 app이면 getAuth(app)로 재사용"만 담당한다 —
 * 오류를 삼켜 숨기는 게 아니라 초기화를 멱등하게 만드는 것이고,
 * 중복 호출의 실제 원인(기본 app 오조회)은 각 모듈의 app 싱글턴 처리에서 따로 제거했다.
 * auth/already-initialized 외의 오류는 그대로 다시 던져 설정 문제를 감추지 않는다.
 */
export function getOrInitializeAuth(app, options) {
  if (!app) return null
  try {
    return initializeAuth(app, options)
  } catch (error) {
    if (error?.code === 'auth/already-initialized') return getAuth(app)
    throw error
  }
}
